var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-dashboard-video-card",class:{
    large: _vm.size === 'lg',
    medium: _vm.size === 'md',
  }},[_c('dashboard-base-card',{staticClass:"h-full",attrs:{"hasBorder":false}},[_vm._t("default")],2),(_vm.$slots.action)?_c('div',[_vm._t("action")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }